export default __webpack_public_path__ + "static/media/adonai_2.72869030.jpg";